<div fxFlex fxLayout="row" class="w-mat-timepicker">
  <mat-form-field fxFlex class="timeContainer">
    <mat-label>{{ placeholder ? placeholder : '' }}</mat-label>
    <input
      matInput
      class="timeInput"
      [placeholder]="placeholder ? placeholder : ''"
      [value]="time"
    />
    <button
      mat-icon-button
      matSuffix
      (click)="showPicker()"
      class="time-picker-button"
    >
      <mat-icon>access_time</mat-icon>
    </button>
  </mat-form-field>
</div>
